import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";

interface ComplianceData {
    compliance_id: string;
    total_controls: number;
    compliance_code: string; // Match the new key format
  }
  
  interface BarChartProps {
    data: ComplianceData[];
  }
  
  const ComplianceBarChart: React.FC<BarChartProps> = ({ data }) => {
    return (
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 20 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="compliance_code" />
          <YAxis />
          <Tooltip />
          <Bar dataKey="total_controls" fill="#8884d8" barSize={20} />
        </BarChart>
      </ResponsiveContainer>
    );
  };
  
export default ComplianceBarChart;
